import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../../services/api'
import IncomeReportPage from './IncomeReportPage'
import SummaryActsReportPreview from '../SummaryActsReportPreview'
import { REPORT_TYPE_SUMMARY_BUDGET } from './IncomeReportComponents'

// Диспетчер просмотра отчёта по типу: квартальный по доходам или снимок «Сводного бюджета».
function ReportDetailRoute() {
  const { id } = useParams()
  const [reportType, setReportType] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    setError('')
    setReportType(null)
    api.get(`/company/reports/${id}`)
      .then((response) => {
        if (!cancelled) setReportType(response.data?.report?.type || 'income_quarterly')
      })
      .catch((err) => {
        if (!cancelled) setError(err.response?.data?.error || 'Не удалось загрузить отчет')
      })
    return () => { cancelled = true }
  }, [id])

  if (error) {
    return (
      <div className="company-page">
        <div className="message message-error" role="alert">{error}</div>
      </div>
    )
  }
  if (!reportType) {
    return <div className="loading">Загрузка...</div>
  }
  if (reportType === REPORT_TYPE_SUMMARY_BUDGET) {
    return <SummaryActsReportPreview reportId={id} />
  }
  return <IncomeReportPage />
}

export default ReportDetailRoute
